// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");
var Curry = require("bs-platform/lib/js/curry.js");
var Belt_Id = require("bs-platform/lib/js/belt_Id.js");
var Belt_Map = require("bs-platform/lib/js/belt_Map.js");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BeltHoles_List = require("belt-holes/src/BeltHoles_List.bs.js");
var Belt_MapString = require("bs-platform/lib/js/belt_MapString.js");
var Pin$XodProject = require("./Pin.bs.js");
var Link$XodProject = require("./Link.bs.js");
var Node$XodProject = require("./Node.bs.js");
var BeltHoles_Option = require("belt-holes/src/BeltHoles_Option.bs.js");
var Patch$XodProject = require("./Patch.bs.js");
var Project$XodProject = require("./Project.bs.js");
var Position$XodProject = require("./Position.bs.js");
var BeltHoles_Map_String = require("belt-holes/src/BeltHoles_Map_String.bs.js");
var PatchPath$XodProject = require("./PatchPath.bs.js");

function getMatchingBusNodes(patch) {
  var nodes = Patch$XodProject.listNodes(patch);
  var toBusNodesByLabel = BeltHoles_Map_String.keepMap(Belt_MapString.keep(BeltHoles_List.groupByString(Belt_List.keep(nodes, (function (n) {
                      return PatchPath$XodProject.isToBus(Node$XodProject.getType(n));
                    })), Node$XodProject.getLabel), (function (param, ns) {
              return Belt_List.length(ns) === 1;
            })), Belt_List.head);
  if (Belt_MapString.isEmpty(toBusNodesByLabel)) {
    return /* [] */0;
  } else {
    return Belt_List.fromArray(Belt_MapString.valuesToArray(Belt_MapString.mapWithKey(Belt_MapString.keep(BeltHoles_List.groupByString(Belt_List.keep(nodes, (function (n) {
                                      return PatchPath$XodProject.isFromBus(Node$XodProject.getType(n));
                                    })), Node$XodProject.getLabel), (function (label, param) {
                              return Belt_MapString.has(toBusNodesByLabel, label);
                            })), (function (label, fbNodes) {
                          return /* tuple */[
                                  Belt_MapString.getExn(toBusNodesByLabel, label),
                                  fbNodes
                                ];
                        }))));
  }
}

function linkifyPatch(originalPatch, matchingBusNodes) {
  return Belt_List.reduce(matchingBusNodes, originalPatch, (function (patch, param) {
                var fromBusNodes = param[1];
                var toBusNodeId = Node$XodProject.getId(param[0]);
                var linksByOutputNodeId = BeltHoles_List.groupByString(Patch$XodProject.listLinks(patch), Link$XodProject.getOutputNodeId);
                return Belt_Option.mapWithDefault(Belt_List.head(Belt_List.keep(Patch$XodProject.listLinks(patch), (function (l) {
                                      return Link$XodProject.getInputNodeId(l) === toBusNodeId;
                                    }))), patch, (function (linkFromSource) {
                              var sourceNodeId = Link$XodProject.getOutputNodeId(linkFromSource);
                              var sourcePinKey = Link$XodProject.getOutputPinKey(linkFromSource);
                              var linksFromSourceToBusDestinations = Belt_List.map(Belt_List.flatten(Belt_List.map(fromBusNodes, (function (fromBusNode) {
                                              return Belt_MapString.getWithDefault(linksByOutputNodeId, Node$XodProject.getId(fromBusNode), /* [] */0);
                                            }))), (function (link) {
                                      return Link$XodProject.create(Link$XodProject.getInputPinKey(link), Link$XodProject.getInputNodeId(link), sourcePinKey, sourceNodeId);
                                    }));
                              var dissocFromBusNodes = function (patchWithFromBusNodes) {
                                return Belt_List.reduce(fromBusNodes, patchWithFromBusNodes, (function (accP, n) {
                                              return Patch$XodProject.dissocNode(accP, Node$XodProject.getId(n));
                                            }));
                              };
                              return Patch$XodProject.upsertLinks(dissocFromBusNodes(Patch$XodProject.dissocNode(patch, toBusNodeId)), linksFromSourceToBusDestinations);
                            }));
              }));
}

function linkifyPatchRecursively(project, entryPatchPath) {
  return Project$XodProject.upsertPatches(project, Belt_List.map(Belt_List.keepMap(Belt_List.add(Project$XodProject.getPatchDependencies(project, entryPatchPath), entryPatchPath), (function (param) {
                        return Project$XodProject.getPatchByPath(project, param);
                      })), (function (p) {
                    return linkifyPatch(p, getMatchingBusNodes(p));
                  })));
}

function getLinkOutput(link) {
  return /* tuple */[
          Link$XodProject.getOutputNodeId(link),
          Link$XodProject.getOutputPinKey(link)
        ];
}

var cmp = Caml_obj.caml_compare;

var LinkEndComparator = Belt_Id.MakeComparable({
      cmp: cmp
    });

function splitLinksToBuses(getBusPosition, patchPath, linkIds, project) {
  var match = Project$XodProject.getPatchByPath(project, patchPath);
  if (match !== undefined) {
    var patch = Caml_option.valFromOption(match);
    var linksToSplit = Belt_List.keep(Belt_List.keep(Patch$XodProject.listLinks(patch), (function (link) {
                return Belt_List.has(linkIds, Link$XodProject.getId(link), (function (prim, prim$1) {
                              return prim === prim$1;
                            }));
              })), (function (link) {
            var isInputConnectedToBusNode = Belt_Option.mapWithDefault(Patch$XodProject.getNodeById(patch, Link$XodProject.getInputNodeId(link)), false, (function (n) {
                    return PatchPath$XodProject.isToBus(Node$XodProject.getType(n));
                  }));
            var isOutputConnectedToBusNode = Belt_Option.mapWithDefault(Patch$XodProject.getNodeById(patch, Link$XodProject.getOutputNodeId(link)), false, (function (n) {
                    return PatchPath$XodProject.isFromBus(Node$XodProject.getType(n));
                  }));
            if (isOutputConnectedToBusNode) {
              return false;
            } else {
              return !isInputConnectedToBusNode;
            }
          }));
    var match$1 = Belt_List.reduce(Belt_List.map(Belt_Map.toList(Belt_Map.mapWithKey(BeltHoles_List.groupBy(linksToSplit, LinkEndComparator, getLinkOutput), (function (param, links) {
                        var pinKey = param[1];
                        var nodeId = param[0];
                        var match = BeltHoles_Option.getWithLazyDefault(Belt_List.head(Belt_List.keepMap(Belt_List.keep(Patch$XodProject.listLinks(patch), (function (link) {
                                            return Caml_obj.caml_equal(getLinkOutput(link), /* tuple */[
                                                        nodeId,
                                                        pinKey
                                                      ]);
                                          })), (function (link) {
                                        return Belt_Option.map(Belt_Option.flatMap(Patch$XodProject.getNodeById(patch, Link$XodProject.getInputNodeId(link)), (function (node) {
                                                          if (PatchPath$XodProject.isToBus(Node$XodProject.getType(node))) {
                                                            return Caml_option.some(node);
                                                          }
                                                          
                                                        })), (function (node) {
                                                      return /* tuple */[
                                                              link,
                                                              node
                                                            ];
                                                    }));
                                      }))), (function (param) {
                                var match = Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(Patch$XodProject.getNodeById(patch, nodeId), (function (outputNode) {
                                                return Belt_Option.map(Belt_Option.flatMap(Project$XodProject.getPatchByNode(project, outputNode), (function (__x) {
                                                                  return Patch$XodProject.getPinByKey(__x, pinKey);
                                                                })), (function (outputPin) {
                                                              return /* tuple */[
                                                                      outputNode,
                                                                      outputPin
                                                                    ];
                                                            }));
                                              })), (function (param) {
                                            var outputPin = param[1];
                                            var outputNode = param[0];
                                            var label = Node$XodProject.isPinNode(outputNode) ? Node$XodProject.getLabel(outputNode) : Pin$XodProject.getLabel(outputPin);
                                            var busPosition = Curry._2(getBusPosition, outputNode, outputPin);
                                            return /* tuple */[
                                                    label,
                                                    busPosition
                                                  ];
                                          })), /* tuple */[
                                      "",
                                      Position$XodProject.origin
                                    ]);
                                var toBusNode = Node$XodProject.setPosition(Node$XodProject.setLabel(Node$XodProject.create($dot$dot.TO_BUS_PATH), match[0]), match[1]);
                                return /* tuple */[
                                        Link$XodProject.create("__in__", Node$XodProject.getId(toBusNode), pinKey, nodeId),
                                        toBusNode
                                      ];
                              }));
                        var toBusNode = match[1];
                        var busNodesLabel = Node$XodProject.getLabel(toBusNode);
                        var fromBusNodesAndLinks = Belt_List.keepMap(Belt_List.keepMap(links, (function (link) {
                                    return Belt_Option.map(Patch$XodProject.getNodeById(patch, Link$XodProject.getInputNodeId(link)), (function (destinationNode) {
                                                  return /* tuple */[
                                                          link,
                                                          destinationNode
                                                        ];
                                                }));
                                  })), (function (param) {
                                var destinationNode = param[1];
                                var destinationPinKey = Link$XodProject.getInputPinKey(param[0]);
                                return Belt_Option.map(Belt_Option.flatMap(Project$XodProject.getPatchByNode(project, destinationNode), (function (__x) {
                                                  return Patch$XodProject.getVariadicPinByKey(__x, destinationNode, destinationPinKey);
                                                })), (function (destinationPin) {
                                              var fromBusPosition = Curry._2(getBusPosition, destinationNode, destinationPin);
                                              var fromBusNode = Node$XodProject.setPosition(Node$XodProject.setLabel(Node$XodProject.create($dot$dot.FROM_BUS_PATH), busNodesLabel), fromBusPosition);
                                              return /* tuple */[
                                                      Link$XodProject.create(destinationPinKey, Node$XodProject.getId(destinationNode), "__out__", Node$XodProject.getId(fromBusNode)),
                                                      fromBusNode
                                                    ];
                                            }));
                              }));
                        return Belt_List.reduce(fromBusNodesAndLinks, /* tuple */[
                                    /* :: */[
                                      match[0],
                                      /* [] */0
                                    ],
                                    /* :: */[
                                      toBusNode,
                                      /* [] */0
                                    ]
                                  ], (function (param, param$1) {
                                      return /* tuple */[
                                              /* :: */[
                                                param$1[0],
                                                param[0]
                                              ],
                                              /* :: */[
                                                param$1[1],
                                                param[1]
                                              ]
                                            ];
                                    }));
                      }))), (function (prim) {
                return prim[1];
              })), /* tuple */[
          /* [] */0,
          /* [] */0
        ], (function (param, param$1) {
            return /* tuple */[
                    Belt_List.concat(param[0], param$1[0]),
                    Belt_List.concat(param[1], param$1[1])
                  ];
          }));
    return Project$XodProject.assocPatch(project, patchPath, Patch$XodProject.upsertLinks(Patch$XodProject.upsertNodes(Patch$XodProject.omitLinks(patch, linksToSplit), match$1[1]), match$1[0]));
  } else {
    return project;
  }
}

exports.getMatchingBusNodes = getMatchingBusNodes;
exports.linkifyPatch = linkifyPatch;
exports.linkifyPatchRecursively = linkifyPatchRecursively;
exports.splitLinksToBuses = splitLinksToBuses;
/* LinkEndComparator Not a pure module */



// WEBPACK FOOTER //
// ../src/Buses.bs.js